import {
  getStockStatusIndicatorColor,
  getStockStatusText,
} from "@coworker/app/src/components/RoomSettings/Molecules/ArticleStock.helper";
import { useAvailableElevatedStock } from "@coworker/app/src/hooks/useAvailableElevatedStock";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import CircleHalfIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CircleHalfIconPath";
import FixaStatus from "@coworker/apprestructured/src/shared/wrappers/FixaStatus/FixaStatus";
import useTranslation from "../../../../../../packages/locales/translations/util/useTranslation";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { ItemNoAndType } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";

interface StockStatusProps {
  itemNoAndType: ItemNoAndType;
}

export const StockStatus = ({ itemNoAndType }: StockStatusProps) => {
  const { t } = useTranslation();

  const fullId = `${itemNoAndType.type}${itemNoAndType.no}`;
  const { available, elevated, loading } = useAvailableElevatedStock(fullId);

  const stockStatusColor = getStockStatusIndicatorColor(available, elevated);
  const stockStatusText = getStockStatusText(available, elevated);

  const elevatedStatus = !elevated ? "(0)" : `(${elevated})`;
  const addOnContent = (
    <FixaStatus
      label={`${available} ${elevatedStatus}`}
      variant={stockStatusColor}
      small
    />
  );
  return (
    <FixaListViewItem
      size="medium"
      control="default"
      inset
      leadingIcon={CircleHalfIconPath}
      controlIcon="chevronRight"
      id="media-placement-group-1"
      title={<FixaText textStyle="Heading.XS">Stock status</FixaText>}
      description={t(stockStatusText)}
      addOn={loading ? t("loadingString") : addOnContent}
    ></FixaListViewItem>
  );
};
